import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import Login from './components/Login';
import Register from './components/Register';
import ArticleProcessor from './components/ArticleProcessor';
import VocabularyManager from './components/VocabularyManager';
import { AuthProvider } from './utils/AuthContext';

function App() {
  return (
    <AuthProvider>
      <div className="app">
        <Header />
        <main className="container">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/process" element={<ArticleProcessor />} />
            <Route path="/vocabulary" element={<VocabularyManager />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <footer className="container">
          <p>&copy; {new Date().getFullYear()} English Vocabulary Helper</p>
        </footer>
      </div>
    </AuthProvider>
  );
}

export default App;
